var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(this.$route.meta.layout || _vm.layout,{tag:"component",scopedSlots:_vm._u([{key:"layout",fn:function(){return [_c('router-view',{key:_vm.$route.fullPath,scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c(Component,{ref:"mainContent",tag:"component"})]}}])})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }